<!--
 * @LastEditors: chuhongguang
 * @desc: 提示弹窗内的模板
 * @场景: 重构公式 抽屉 - 提交/保存
-->
<template>
  <div>
    <div style="height: 30px;">
      <span v-show="this.tishi !== 'ok'" class="italicFont">
        <span v-if="this.tishi === 'only_number'">*全为数字不通过</span>
        <span v-else-if="this.tishi === 'exist' && !this.detectionSuccess.is_matrix">
          <span v-if="this.reconstructionSelect === '1' && this.is_asset === false">*与已有数据重名，点击“确定”覆盖原数据？覆盖后依赖该数据的重构因子会发生变化，需手动重新计算</span>
          <span v-else-if="this.reconstructionSelect === '2' && this.is_asset === true">*与已有资产重名，点击“确定”覆盖原资产？覆盖后依赖该资产的重构因子会发生变化，需手动重新计算</span>
          <span v-else>*资产与数据重名无法进行覆盖操作，请做修改</span>
        </span>
        <span v-else-if="this.tishi === 'exist'">*数据重名无法进行覆盖操作，请做修改</span>
        <span v-else>{{this.tishi}}</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['tishi', 'reconstructionSelect', 'detectionSuccess', 'is_asset'],
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/allPage/tishiBox.vue